


















































































































































































import ICompanyAdresses from '@/store/models/ICompanyAdresses';
import IListCountries from '@/store/models/IListCountries';
import IListAdressTypes from '@/store/models/IListAdressTypes';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class CompanyAdressesSelector extends Vue {
    searchCompanyAdresses: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    headers: any = [
        { text: 'Street',
            align: 'start',
            value: 'street'
        },
        { text: 'Number', value: 'number' },
        { text: 'City', value: 'city' },
        { text: 'ZipCode', value: 'zipCode' },
        { text: 'CountryName', value: 'countryName' },
        { text: 'Code', value: 'code' },
        { text: 'TypeName', value: 'typeName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : ICompanyAdresses = {
        id: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idCompany: "",
        idListAdressType: "",
        typeName: ""
    }
    defaultItem : ICompanyAdresses = {
        id: "",
        street: "",
        number: "",
        city: "",
        zipCode: "",
        idListCountry: "",
        countryName: "",
        code: "",
        idCompany: "",
        idListAdressType: "",
        typeName: ""
    }
    sortBy: string = 'street';
    sortDesc: boolean = false;

    @Prop({ type: Array, required: true })
    CompanyAdressesList !: ICompanyAdresses[];
    @Prop({ type: Array, required: true })
    ListCountries !: IListCountries[];
    @Prop({ type: Array, required: true })
    ListAdressTypes !: IListAdressTypes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    
    selectedCompanyAdres : ICompanyAdresses[] = [];
    selectedCountry: any = null;
    selectedAdressType: any = null;

    get formTitle() { return this.editedIndex === -1 ? 'New Adress' : 'Edit Adress'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    editCompanyAdresses (item: any, dbox = true) {
        if (this.selectedCompanyAdres.length > 0) {
            this.editedIndex = this.CompanyAdressesList.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.selectedCountry = this.ListCountries.find(p => p.id === this.editedItem.idListCountry);
            this.selectedAdressType = this.ListAdressTypes.find(p => p.id === this.editedItem.idListAdressType);
            this.dialog = true;
        }
    }

    saveCompanyAdresses () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            this.setCountry();
            this.setTypeName();
            if (this.editedIndex > -1) {
                this.$emit('editCompanyAdress', this.editedItem);
                Object.assign(this.CompanyAdressesList[this.editedIndex], this.editedItem);
            } else {
                this.$emit('saveCompanyAdress', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageInfo', 'All required fields must be filled out');
        }
    }

    deleteCompanyAdresses (companyAdres: ICompanyAdresses) {
        if (this.selectedCompanyAdres.length > 0) {
            this.$emit('deleteCompanyAdress', companyAdres);
            this.close();
        }
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    setCountry() {
        if (this.selectedCountry) {
            let country: IListCountries = this.ListCountries.find(p => p.countryName === this.selectedCountry.countryName)!;
            if (country) {
                this.editedItem.idListCountry = country.id;
                this.editedItem.countryName = country.countryName;
                this.editedItem.code = country.code;
            }
        }
    }

    setTypeName() {
        if (this.selectedAdressType) {
            let adresType: IListAdressTypes = this.ListAdressTypes.find(p => p.typeName === this.selectedAdressType.typeName)!;
            if (adresType) {
                this.editedItem.idListAdressType = adresType.id;
                this.editedItem.typeName = adresType.typeName;
            }
        }
    }

    select(item : ICompanyAdresses) : void {
        let index : number = this.selectedCompanyAdres.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedCompanyAdres = [item];
        } else {
            let companyAdres = this.selectedCompanyAdres.find(w => w.id === item.id);
            if (!companyAdres) {
                this.selectedCompanyAdres = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
